export default "__VITE_ASSET__7cef1672__"